import { render, staticRenderFns } from "./CancelMenuView.vue?vue&type=template&id=67378128&"
import script from "./CancelMenuView.vue?vue&type=script&lang=js&"
export * from "./CancelMenuView.vue?vue&type=script&lang=js&"
import style0 from "./CancelMenuView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VRow})
